import { cn } from '@/core/utils/common'

type SkeletonVariant = 'text' | 'circular' | 'rectangular'

type SkeletonProps = {
  className?: string
  variant?: SkeletonVariant
  width?: string | number
  height?: string | number
}

export default function Skeleton({
  className,
  variant = 'text',
  width,
  height,
}: SkeletonProps) {
  return (
    <div
      className={cn(
        'animate-pulse bg-foreground/10',
        variant === 'text' && 'h-4 rounded-control',
        variant === 'circular' && 'rounded-full',
        variant === 'rectangular' && 'rounded-control',
        className
      )}
      style={{ width, height }}
    />
  )
}
